/**
 * Which container and bitrate a recording is made in. Pure and Angular-free: the
 * caller passes what the platform says it supports.
 *
 * There is no one format every target records. WebKit writes MP4 with AAC and
 * Chromium writes WebM with Opus, so a hard-coded type records nothing on one of
 * the two platforms this app ships to.
 */

/** In preference order. Opus carries speech at a lower rate than AAC, where there is a choice. */
const CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/mp4',
  'audio/ogg;codecs=opus',
];

/**
 * Speech, not music. The recorder's own default is a stereo music setting and
 * spends several times the disk for nothing a recogniser can use.
 */
export const SPEECH_BITS_PER_SECOND = 32000;

/**
 * The best supported container, or null where the platform records none of them —
 * in which case the session cannot keep audio and the rep must be told, rather
 * than being left recording into nothing.
 */
export function pickRecordingType(isSupported: (type: string) => boolean): string | null {
  for (const candidate of CANDIDATES) {
    try {
      if (isSupported(candidate)) {
        return candidate;
      }
    } catch {
      // A platform that throws on a type it does not know has refused it.
    }
  }
  return null;
}
